import React from "react";
import { Routes, Route } from "react-router-dom";
// import HeaderRanking from "../Components/Ranking/headerRanking";
// import ListBuilderRating from "../Components/Ranking/listBuilderRanking";
import ListReelRating from "../Components/Reel Ranking/listReelRanking";
// import ListProjectVideoRating from "../Components/Ranking/listVideoRanking";

const ReelRankingRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/ranking" element={<HeaderRanking></HeaderRanking>}></Route> */}
      {/* <Route path="/ranking_builder_list" element={<ListBuilderRating></ListBuilderRating>}></Route> */}
      <Route path="/reels" element={<ListReelRating></ListReelRating>}></Route>
      {/* <Route path="/ranking_video_list" element={<ListProjectVideoRating></ListProjectVideoRating>}></Route> */}
    </Routes>
  );
};

export default ReelRankingRoutes;
